export const teamManagement = {
  forbidden: {
    title: "Acceso restringido",
    desc: "Solo el anfitrión principal puede gestionar el equipo.",
  },
  header: {
    title: "Gestión de Equipo",
    subtitle: "Administra quién puede acceder al panel de tu alojamiento",
    addMember: "Agregar miembro",
  },
  stats: {
    totalTeam: "Total en el equipo",
    host: "Anfitrión",
    additionalMembers: "Miembros adicionales",
  },
  search: {
    placeholder: "Buscar por nombre o correo…",
  },
  loading: "Cargando equipo…",
  table: {
    member: "Miembro",
    email: "Correo",
    role: "Rol",
    properties: "Propiedades",
    added: "Agregado",
    actions: "Acciones",
    ownerBadge: "Anfitrión",
    mainHost: "Anfitrión Principal",
    viewPermissions: "Ver funciones permitidas",
    allProperties: "Todas",
    unassigned: "Sin asignar",
    notEditable: "No editable",
    edit: "Editar",
    delete: "Eliminar",
  },
  surfaces: {
    web: "Web",
    app: "App",
  },
  empty: {
    title: "Sin miembros adicionales",
    desc: "Usa el botón <strong>Agregar miembro</strong> para invitar personas a tu equipo.",
  },
  infoBanner:
    "Los miembros del equipo acceden al panel con su propio usuario y contraseña. Cada perfil tiene permisos fijos y el acceso a datos se limita desde el servidor. Propietario entra solo por web; limpieza y mantenimiento, solo por la app. El <strong>anfitrión principal</strong> siempre tiene acceso completo y no puede ser eliminado.",
  modal: {
    createTitle: "Agregar miembro",
    editTitle: "Editar miembro",
    nameLabel: "Nombre completo",
    namePlaceholder: "Ej. María García",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "correo@ejemplo.com",
    roleLabel: "Perfil de acceso",
    viewScope: "Ver alcance",
    accessIncluded: "Acceso incluido",
    assignedProperties: "Propiedades asignadas",
    selectedCount: "({selected} de {total} seleccionadas)",
    propertySearchPlaceholder: "Buscar propiedad…",
    selectAll: "Seleccionar todas",
    clear: "Limpiar",
    noResults: 'Sin resultados para "{query}"',
    selectAtLeastOneHint: "Selecciona al menos una propiedad para este perfil.",
    noPropertiesWarning:
      "No hay propiedades disponibles para asignar. Crea una propiedad antes de guardar este perfil.",
    passwordLabel: "Contraseña",
    passwordOptional: "(dejar vacío para no cambiar)",
    passwordPlaceholder: "Mínimo 8 caracteres",
    confirmPasswordLabel: "Confirmar contraseña",
    confirmPasswordPlaceholder: "Repetir contraseña",
    showPassword: "Ver la contraseña",
    hidePassword: "Ocultar la contraseña",
    cancel: "Cancelar",
    create: "Crear miembro",
    save: "Guardar cambios",
  },
  deleteModal: {
    title: "Eliminar miembro",
    subtitle: "Esta acción no se puede deshacer",
    confirm:
      "¿Estás seguro de que deseas eliminar a {name} del equipo? Perderá el acceso al panel inmediatamente.",
    cancel: "Cancelar",
    delete: "Eliminar",
  },
  roleInfo: {
    defaultTitle: "Permisos",
    description:
      "Este perfil es fijo. Su alcance, superficie de acceso y propiedades se validan también en el servidor.",
    understood: "Entendido",
  },
  roleDescriptions: {
    anfitrion: "Acceso completo a todas las propiedades desde web y app.",
    propietario:
      "Solo calendarios y analíticas de las propiedades asignadas. Acceso web.",
    limpieza:
      "Inicio de limpieza, tareas y mensajes de sus propiedades. Solo app.",
    mantenimiento:
      "Inicio de mantenimiento, tareas y mensajes de sus propiedades. Solo app.",
    fallback: "Perfil de compatibilidad con acceso restringido.",
  },
  optionalHints: {
    messages:
      "Ver y responder los chats de sus propiedades. Si se desactiva, no verá mensajes ni recibirá sus notificaciones.",
  },
  toasts: {
    loadError: "No se pudo cargar el equipo.",
    memberAdded: "✓ Miembro agregado al equipo.",
    memberUpdated: "✓ Miembro actualizado.",
    saveError: "No se pudo guardar. Intenta de nuevo.",
    memberDeleted: "Miembro eliminado del equipo.",
    deleteError: "No se pudo eliminar el miembro.",
  },
};
